import { GTM_ENV_VAR, PAGE_TYPES } from '../../lib/eventTrackerFunction'

const TRACKER_CONSTANTS = {
  LANDED_SEC_CAMPAIGN_PAGE: 'landed_sec_campaign_page',
  ON_VIEW_DETAILS_CLICK: 'on_view_details_click',
  ON_SAVE_CLICK: 'on_save_click',
  OPEN_SEC_DOWNLOAD_POPUP: 'open_sec_download_popup',
  ON_APP_DOWNLOAD_CLICK: 'on_app_download_click',
}

const SEC_COMMON_ATTRS = {
  [GTM_ENV_VAR.PAGE_TYPE]: PAGE_TYPES.PROMOTION,
  [GTM_ENV_VAR.EVENT]: 'hm_push_event',
  [GTM_ENV_VAR.EVENT_CAT]: 'SEC_Campaign-app',
  [GTM_ENV_VAR.SCREEN_NAME_GA4]: 'grocery-online | sec',
  [GTM_ENV_VAR.SCREEN_NAME]: 'grocery-online | sec',
  [GTM_ENV_VAR.ASSET_TYPE]: 'fpon',
}

const eventsDataset = {
  [TRACKER_CONSTANTS.LANDED_SEC_CAMPAIGN_PAGE]: {
    ...SEC_COMMON_ATTRS,
    [GTM_ENV_VAR.EVENT_LABEL]: 'SEC-Main',
    [GTM_ENV_VAR.EVENT_ACTION]: 'Landed',
  },
  [TRACKER_CONSTANTS.ON_VIEW_DETAILS_CLICK]: {
    ...SEC_COMMON_ATTRS,
    [GTM_ENV_VAR.EVENT_LABEL]: 'SEC-view details',
    [GTM_ENV_VAR.EVENT_ACTION]: 'Click',
  },
  [TRACKER_CONSTANTS.ON_SAVE_CLICK]: {
    ...SEC_COMMON_ATTRS,
    [GTM_ENV_VAR.EVENT_LABEL]: 'SEC-save',
    [GTM_ENV_VAR.EVENT_ACTION]: 'Click',
  },
  [TRACKER_CONSTANTS.OPEN_SEC_DOWNLOAD_POPUP]: {
    ...SEC_COMMON_ATTRS,
    [GTM_ENV_VAR.EVENT_LABEL]: 'SEC - prompt',
    [GTM_ENV_VAR.EVENT_ACTION]: 'Pop-Up Message',
  },
  [TRACKER_CONSTANTS.ON_APP_DOWNLOAD_CLICK]: {
    ...SEC_COMMON_ATTRS,
    [GTM_ENV_VAR.EVENT_LABEL]: 'SEC - download',
    [GTM_ENV_VAR.EVENT_ACTION]: 'Click',
  },
}

export { GTM_ENV_VAR, TRACKER_CONSTANTS, eventsDataset }
